import type { TestingChatActivity } from "@/stores/testingStore";

/** Returns a color class for the plan status dot in the list. */
export function planStatusDotClass(status: string): string {
	if (status === "passed") return "bg-emerald-500";
	if (status === "failed") return "bg-red-500";
	if (status === "approved") return "bg-primary/60";
	if (status === "proposed") return "bg-yellow-500/70";
	return "bg-muted-foreground/30";
}

export function relativeTime(dateStr: string | null | undefined): string {
	if (!dateStr) return "";
	const diff = Date.now() - new Date(dateStr).getTime();
	const m = Math.floor(diff / 60_000);
	if (m < 1) return "just now";
	if (m < 60) return `${m}m ago`;
	const h = Math.floor(m / 60);
	if (h < 24) return `${h}h ago`;
	const d = Math.floor(h / 24);
	return `${d}d ago`;
}

export function isCredentialError(msg: string): boolean {
	return (
		msg.toLowerCase().startsWith("sf credentials:") ||
		msg.includes("user_not_in_org") ||
		msg.includes("/token returned 401")
	);
}

/** Compact token count for the usage indicator: 980 → "980", 1234 → "1.2k", 45000 → "45k". */
export function formatTokens(n: number): string {
	if (n >= 1000) return `${(n / 1000).toFixed(n >= 10000 ? 0 : 1)}k`;
	return String(n);
}

export function formatActivityTime(ts: number): string {
	const seconds = Math.max(0, Math.round((Date.now() - ts) / 1000));
	if (seconds < 1) return "now";
	if (seconds < 60) return `${seconds}s`;
	return `${Math.floor(seconds / 60)}m`;
}

export function formatBytes(bytes: number): string {
	if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";
	if (bytes < 1024) return `${bytes} B`;
	if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
	return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function activityKindLabel(kind: TestingChatActivity["kind"]): string {
	switch (kind) {
		case "schema": return "schema";
		case "metadata": return "metadata";
		case "salesforce": return "salesforce";
		case "browser": return "browser";
		case "evidence": return "evidence";
		case "question": return "question";
		case "plan": return "plan";
		case "tool": return "tool";
		case "result": return "result";
		case "ai_recovery": return "AI fix";
		case "cleanup": return "cleanup";
		default: return "activity";
	}
}
